<!-- Integrer le top de chaque page -->
<app-header></app-header>
<!-- Integrer le carcase de chaque page -->
<div class="container-fluid page-body-wrapper">
  <app-menu></app-menu>
  <div class="main-panel">
    <div class="content-wrapper b-white">
      <!-- Contenu de la page liste des periodiques -->
      <!-- Quick Action Toolbar Ends-->
      <div class="page-header pt-3">
        <div  class="d-sm-flex align-items-baseline report-summary-header w-100 mt-3">
          <h4 class="font-weight-semibold text-initial ">{{ 'logs.menu-logs' | translate}}  </h4>
          <span  class="ml-auto "><button type="button" class="btn btn-secondary btn-sm mb-1" routerLink="/accueil">
                <i class="icon-action-undo btn-icon-prepend"></i> {{ 'btn-return' | translate}} </button>
              </span>
        </div>
      </div>
      <div class="row">
          <div class="col-xl-6 col-sm-6 col-md-6">
            <div class="card text-white bg-danger o-hidden h-100">
              <div class="card-body">
                <div class="card-body-icon">
                  <i class="icon-layers"></i>
                </div>
                <div class="mr-5"><h1 class="font-size-3 text-white">{{totalLogsRevue}}</h1> </div>
                <h4>{{ 'logs.titre-logs-revue' | translate}}</h4>
              </div>
              <a class="card-footer text-white clearfix small z-1" routerLink="/logs-revue">
                <span class="float-left">{{ 'voir-details' | translate}}</span>
                <span class="float-right">
                <i class="fa fa-angle-right"></i>
              </span>
              </a>
            </div>
          </div>
          <div class="col-xl-6 col-sm-6 col-md-5">
            <div class="card text-white bg-info o-hidden h-100">
              <div class="card-body">
                <div class="card-body-icon">
                  <i class="fa fa-fw fa-list"></i>
                </div>
                <div class="mr-5"><h1 class="font-size-3 text-white">{{totalLogsPlat}}</h1></div>
                <h4>{{ 'logs.titre-logs-plateforme' | translate}}</h4>
              </div>
              <a class="card-footer text-white clearfix small z-1" routerLink="/logs-plateforme">
                <span class="float-left">{{ 'voir-details' | translate}}</span>
                <span class="float-right">
                <i class="fa fa-angle-right"></i>
              </span>
              </a>
            </div>
          </div>
        </div>
    </div>
      <!-- Contenu footer -->
      <app-footer></app-footer>
    </div>
  </div>
